import Flex from "@irati/ui/src/Flex"
import styled from "styled-components"

export const YearOptionContainer = styled(Flex)`
  > * {
    flex: 1;
  }
`
